<template>
	<div>
		<botao-voltar label-voltar="Voltar para listagem" :nome-rota-anterior="rotaListagem"></botao-voltar>
		<az-container>
			<v-card elevation="0">
				<v-card-text>
					<formulario-revisao
						:id-revisao="idRevisao"
						:funcao-salvar-revisao="editarRevisao"
					></formulario-revisao>
				</v-card-text>
			</v-card>
		</az-container>
	</div>
</template>

<script>
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import { actionTypes, routesNames } from '@/core/constants'
import FormularioRevisao from '@/views/pages/configuracao/revisoes/formulario-revisao/FormularioRevisao.vue'

export default {
	name: 'revisao-edicao',
	components: { FormularioRevisao, BotaoVoltar },
	data() {
		return {
			idRevisao: Number(this.$route.params.id),
			rotaListagem: routesNames.CONFIGURACAO.REVISOES.REVISOES_VIEW,
		}
	},
	methods: {
		async editarRevisao(payload) {
			const revisao = await this.$store.dispatch(actionTypes.CONFIGURACAO.REVISOES.EDITAR_REVISAO, {
				idRevisao: this.idRevisao,
				body: payload,
			})

			this.mostrarNotificacaoSucessoDefault()

			return revisao
		},
	},
}
</script>
